import * as React from 'react';

declare const rootUrl: string;

interface VitaloJak2ConfigureStepsProps {
    onNext: () => void;
    onBack: () => void;
}

export const VitaloJak2ConfigureSteps = ({ onNext, onBack }: VitaloJak2ConfigureStepsProps) => {
    return (
        <>
            <div className="modal-body">
                <div className="row">
                    <div className="col-md-12">
                        <h2 className="text-primary">Check Audio</h2>
                    </div>
                </div>
                <div className="row">
                    <div className="col-md-12">
                        <ol className="posh-list">
                            <li>Turn the device on using the key</li>
                            <li>Wait until the main menu is displayed<br /><img src={rootUrl + 'Content/Images/Wizards/vitalojak2-buttons.png'} alt="" /></li>
                            <li>Select 'Setup' then 'Audio Level'</li>
                            <li>Ensure both the microphone and chest sensor bar graphs are responding to noise<br /><br /><img src={rootUrl + 'Content/Images/Wizards/vitalojak2-levels.png'} alt="" /></li>
                            <li>Return to the main menu</li>
                        </ol>
                    </div>
                </div>
            </div>
            <div className="modal-footer">
                <button className="btn btn-primary" onClick={onNext}>Next</button>
                <button className="btn btn-primary btn-outline" onClick={onBack}>Back</button>
            </div>
        </>
    );
}
